export const columnsToolPanel = {
  id: 'columns',
  labelDefault: 'Columns',
  labelKey: 'columns',
  iconKey: 'columns',
  toolPanel: 'agColumnsToolPanel',
  toolPanelParams: {
    suppressRowGroups: true,
    suppressValues: true,
    suppressPivots: true,
    suppressPivotMode: true,
    suppressSideButtons: true,
    suppressColumnFilter: true,
    suppressColumnSelectAll: true,
    suppressColumnExpandAll: true,
  },
};

export const filtersToolPanel = {
  id: 'filters',
  labelDefault: 'Filters',
  labelKey: 'filters',
  iconKey: 'filter',
  toolPanel: 'agFiltersToolPanel',
};

